import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import FormManager from '../form/FormManager';
import * as formConfig from './formConfigMfaTan';
import suitcss from '../../helpers/suitcss';
import { mapStateToFormConfig } from './formConfigMfaTan';
import { removeMfa, completeMfa } from '../../actions/mfa/mfa';
import MfaCompleteRequest from '../../model/requests/MfaCompleteRequest';

const MfaTanInputForm = ({ dispatch, hideDialog, ...props }) => {

  const [error, setError] = useState(null);

  const { mfaToken, user } = props;
  const { msisdn } = user.credentials;

  const cancelMfaTanInput = () => {
    dispatch(removeMfa({ mfaToken }));
    dispatch(hideDialog());
  };

  const getSubmitRoute = (fieldMap, finalizedFormValues) => {
    return new MfaCompleteRequest(msisdn, mfaToken, finalizedFormValues.tan);
  };

  const authenticateMfaToken = () => {
    dispatch(hideDialog());
    dispatch(completeMfa({ mfaToken }));
  };

  const cleanError = () => setError(null);
  const handleError = (err) => {
    setError(err.response);
    return false;
  };

  return (
    <div className={suitcss({ componentName: 'MfaTanInputForm', utilities: ['formLayoutNg'] })}>
      <FormManager
        form={MfaTanInputForm.formName}
        stepProps={{
          ...props,
          mfaError: error,
        }}
        submitRoute={getSubmitRoute}
        onCancel={cancelMfaTanInput}
        onAfterSubmitSuccess={authenticateMfaToken}
        steps={[formConfig]}
        withFooter
        withBlockError={false}
        showError={() => {}}
        onSubmitWillFail={handleError}
        onBeforeSubmit={cleanError}
      />
    </div>
  );
};

/**
 * required by tracking!
 */
MfaTanInputForm.formName = 'mfaTan';

MfaTanInputForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
  tanSource: PropTypes.oneOf(['sms']),
  user: PropTypes.object,
  mfaToken: PropTypes.string.isRequired,
};

const mapDispatchToProps = dispatch => ({ dispatch });

export default compose(
  connect(
    mapStateToFormConfig,
    mapDispatchToProps,
  ),
)(MfaTanInputForm);
